import { render, staticRenderFns } from "./grayMonitor.vue?vue&type=template&id=6d9fe61b&scoped=true&"
import script from "./grayMonitor.vue?vue&type=script&lang=js&"
export * from "./grayMonitor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d9fe61b",
  null
  
)

export default component.exports